import { Injectable } from "@angular/core";

@Injectable()
export class AppConfigService{
	public appName: string = "App Launch";
	public appVersion: string = "";
}